import { useStores } from '@root/src/stores';
import { Modal } from '@ui';
import { twcls } from '@utils/twcls';
import { observer } from 'mobx-react';
import { type FC } from 'react';

interface BarMenuConsentModalProps {
  open: boolean;
  onDeny?: () => void;
}

const BarMenuConsentModal: FC<BarMenuConsentModalProps> = observer(
  ({ open, onDeny }) => {
    const { modalsStore } = useStores();
    const { setIsConsentModalAgreed } = modalsStore;
    const handleClose = (): void => {
      modalsStore.setIsConsentModalOpened(false);
    };
    return (
      <Modal
        open={open}
        popupProps={{ arrow: false, closeOnDocumentClick: false }}
        contentStyle={{
          overflow: 'visible'
        }}
        overlayStyle={{
          backgroundColor: 'rgba(0, 0, 0, 0.5)'
        }}
        withoutCross
        framed
        className={twcls(`
                w-[387px]
                max-w-[387px]
                md:w-[387px]
                md:max-w-[387px]
                p-6
                overflow-visible
                h-[249px]
                md:h-[249px]
                md:pb-6
                sm:h-[249px]
                sm:px-3
                sm:pb-8
                sm:rounded-b-none
                sm:rounded-t-xl
                sm:fixed
                sm:left-0
                sm:bottom-0
                sm:overflow-y-auto
                sm:max-w-full
                sm:max-h-full
                sm:w-full
                `)}
      >
        <div
          className='flex flex-col h-full'
          // style={{
          //   padding: '16px 16px 40px',
          //   zIndex: '1000000011',
          //   position: 'fixed',
          //   maxHeight: '386px',
          //   WebkitBackfaceVisibility: 'hidden',
          //   bottom: '0',
          //   width: '100%',
          //   overflowY: 'scroll',
          //   borderRadius: '12px 12px 0 0',
          //   overflowX: 'hidden',
          //   left: '0',
          //   backgroundColor: 'white',
          //   overflow: 'auto'
          // }}
        >
          <h2 className='text-4.5xl font-medium mb-3'>18+</h2>
          <p className='text-base sm:text-sm'>
            Для просмотра необходимо подтвердить свое совершеннолетие и согласие{' '}
            <a
              target='_blank'
              rel='noreferrer'
              href='https://www.delikateska.ru/confidential'
              className='underline'
            >
              на обработку файлов cookies
            </a>{' '}
            и{' '}
            <a href='/pdn' className='underline'>
              обработку ваших персональных данных
            </a>
            .
          </p>
          <div className='flex items-center gap-3 mt-auto'>
            <button
              className={`px-8
          h-12
          flex
          items-center
          justify-center
          w-full
          rounded-lg
          text-sm
          bg-white
          border
          border-solid
          transition-colors
          cursor-pointer
        `}
              onClick={() => {
                onDeny?.();
                setTimeout(() => {
                  handleClose();
                }, 500);
              }}
            >
              Нет
            </button>
            <button
              className={`px-8
          h-12
          flex
          items-center
          justify-center
          w-full
          text-white
          rounded-lg
          text-sm
          bg-[var(--dark-red)]
          transition-colors
          cursor-pointer
        `}
              onClick={() => {
                setIsConsentModalAgreed(true);
                handleClose();
              }}
            >
              Подтверждаю
            </button>
          </div>
        </div>
      </Modal>
      // <Popup

      //   overlayStyle={{
      //     zIndex: '100000011',
      //     backgroundColor: 'rgba(0, 0, 0, 0.2)',
      //     backdropFilter: 'blur(4px)'
      //   }}
      //   contentStyle={{
      //     zIndex: '1000000011'
      //   }}
      //   lockScroll
      //   closeOnDocumentClick={false}
      // >
      //   {(close: () => void) => (

      //   )}
      // </Popup>
    );
  }
);

export default BarMenuConsentModal;
